<template>
    <el-dialog title="照片与文件" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="155px" :inline="true" class="border-form"
            style="margin-right: 25px;">
            <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="标的物" class="item">
                        <span class="set_data">{{ dataForm.subjectName }}</span>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="8" class="set_border">
                    <el-form-item label="范畴" class="item">
                        {{ dataForm.categoryName }}
                    </el-form-item>
                </el-col> -->
                <el-col :span="12">
                    <el-form-item label="专业" class="item">
                        <span class="set_data">{{ dataForm.majorName }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="提出人" class="item">
                        <span class="set_data">{{ dataForm.inspectionMan }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="提出时间" class="item">
                        <span class="set_data">{{ dataForm.inspectionTime | formatDate('yyyy-MM-dd') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="巡检内容" class="item">
                        <span class="set_data">{{ dataForm.inspectionContent }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="问题描述及整改意见" class="item">
                        <span class="set_data">{{ dataForm.sutContent }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="封闭人" class="item">
                        <span class="set_data">{{ dataForm.closeMan }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="封闭时间" class="item">
                        <span class="set_data">{{ dataForm.closeTime | formatDate('yyyy-MM-dd') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="备注" class="item">
                        <span class="set_data">{{ dataForm.remark }}</span>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="整改前照片" class="fileItem">
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;">
                    <el-col :span="8">
                        <el-upload ref="uploadImg" class="upload-demo" action="action" drag :http-request="uploadImg"
                            multiple :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg"
                            :data="{ 'type': '0' }">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </el-col>
                    <el-col :span="16">
                        <div class="addImgBox" v-for="(item, index) in dataForm.scenePhotoList"
                            style="margin-bottom: 10px;">
                            <el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
                            <div class="delBox">
                                <i class="el-icon-delete" @click="delScenePhoto(index)"></i>
                            </div>
                        </div>
                    </el-col>
                </el-col>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="整改后照片" class="fileItem">
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;" class="row-form-item">
                    <el-col :span="8">
                        <el-upload ref="uploadImg" class="upload-demo" action="action" drag :http-request="uploadImg"
                            multiple :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg"
                            :data="{ 'type': '1' }">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </el-col>
                    <el-col :span="16">
                        <div class="addImgBox" v-for="(item, index) in dataForm.closePhotoList"
                            style="margin-bottom: 10px;">
                            <el-image style="width: 100%; height: 100%" :src="item.fileUri" fit="cover"></el-image>
                            <div class="delBox">
                                <i class="el-icon-delete" @click="delClosePhoto(index)"></i>
                            </div>
                        </div>
                    </el-col>
                </el-col>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="封闭文件" class="fileItem">
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="margin-top: 20px;" class="row-form-item">
                    <el-col :span="8">
                        <el-upload ref="uploadFile" class="upload-demo" action="action" drag :http-request="uploadFile"
                            multiple :show-file-list=false :auto-upload="true">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </el-col>
                    <el-col :span="16">
                        <el-table :data="dataForm.closeFileList" :cell-style="{ padding: '0px' }"
                            style="margin-bottom: 20px;" :show-header="false"
                            v-if="dataForm.closeFileList && dataForm.closeFileList.length > 0">
                            <el-table-column width="100" align="center" type="index">
                            </el-table-column>
                            <el-table-column prop="fileName" width="350" align="center">
                                <template slot-scope="scope">
                                    <el-input class="sp-input" v-model="scope.row.fileName"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="150" align="center">
                                <template slot-scope="scope">
                                    <el-button v-preventReClick type="text" size="small"
                                        @click="selectFile(scope.row.fileUri, scope.row.fileName)">查看</el-button>
                                    <el-button v-preventReClick type="text" size="small"
                                        @click="delCloseFile(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-col>
            </el-row>
            <el-row class="formBtnGroup">
                <el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
                <el-button v-preventReClick class="btn" type="primary" size="small" @click="visible = false">取消</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    name: "patrolList-add-or-update",
    data() {
        return {
            inspectionId: '',
            dataForm: {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: ''
            },
            dataRule: {},
            visible: false
        };
    },
    components: {

    },
    activated() {

    },
    filters: {
        formatDate: function (value, args) {
            if (!value) {
                return ''
            }
            var dt = new Date(value);
            if (args == 'yyyy-M-d') {// yyyy-M-d
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                return `${year}-${month}-${date}`;
            } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                let hour = dt.getHours();
                let minute = dt.getMinutes();
                let second = dt.getSeconds();
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${date}`;
            } else {// yyyy-MM-dd HH:mm:ss
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            }
        }
    },
    methods: {
        init(id) {
            this.inspectionId = id;
            this.visible = true;
            this.dataForm = {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: this.inspectionId
            }
            this.getDetail(id)
        },
        // getDetail() {
        //     this.$http({
        //         url: this.$store.state.httpUrl + "/business/inspectionfile/list/" + this.inspectionId,
        //         method: "get",
        //         params: {},
        //     }).then(({ data }) => {
        //         if (data && data.code === 200) {
        //             this.dataForm = data.body
        //         }
        //     });
        // },
        selectFile(url, filename) {
            filename = this.getSuffix(url, filename)
            this.getBlob(url, (blob) => {
                this.saveAs(blob, filename)
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/inspectioninfo/info/" + this.inspectionId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.code === 200) {
                    this.dataForm = data.body;
                    if (!this.dataForm.inspectionMan) {
                        this.dataForm.inspectionMan = $common.getItem("userName");
                    }
                }
            });
        },
        // 删除现场照片
        delScenePhoto(index) {
            let _scenePhotoList = this.dataForm.scenePhotoList;
            _scenePhotoList.splice(index, 1);
            this.dataForm.scenePhotoList = _scenePhotoList;
        },
        // 删除封闭相关文件
        delCloseFile(index) {
            let _closeFileList = this.dataForm.closeFileList;
            _closeFileList.splice(index, 1);
            this.dataForm.closeFileList = _closeFileList;
        },
        // 删除封闭相关图片
        delClosePhoto(index) {
            let _closePhotoList = this.dataForm.closePhotoList;
            _closePhotoList.splice(index, 1);
            this.dataForm.closePhotoList = _closePhotoList;
        },
        // 上传照片
        uploadImg(param) {
            let type = param.data.type;
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadImg.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    if (type == '0') {
                        this.dataForm.scenePhotoList.push({
                            inspectionId: this.inspectionId,
                            recFileType: '0',
                            fileName: res.body.fileName,
                            filePath: res.body.fileSavePath,
                            fileUri: res.body.fileUri
                        });
                    } else if (type == '1') {
                        this.dataForm.closePhotoList.push({
                            inspectionId: this.inspectionId,
                            recFileType: '1',
                            fileName: res.body.fileName,
                            filePath: res.body.fileSavePath,
                            fileUri: res.body.fileUri
                        });
                    }
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        // 上传文件
        uploadFile(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadFile.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.closeFileList.push({
                        inspectionId: this.inspectionId,
                        recFileType: '2',
                        fileName: this.extractFileName(res.body.fileName),
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        dataFormSubmit() {
            this.dataForm.inspectionId = this.inspectionId
            let _url = "/business/inspectionfile/save";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({ data }) => {
                if (data && data.code === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped="scoped">
.addImgBox {
    width: 180px;
    height: 180px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 23px;
}

.set_title {
    margin-left: 10px;
    margin-bottom: 10px;
}

.upload-demo /deep/ .el-upload-dragger {
    width: 260px;
    height: 185px;
}

.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
    font-size: 40px;
    margin: 0 0;
    line-height: 40px;
    padding-top: 45px
}

.upload-demo /deep/ .el-upload-dragger .el-upload__text {
    line-height: 20px;
}

.sp-input /deep/ .el-input__inner {
    width: 100% !important;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    ;
    font-weight: bold !important;
    ;
    background-color: #E1F1FF;
    height: 40px !important;
    border-right: 1px solid #dadada;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.fileItem::v-deep .el-form-item__label {
    text-align: left;
    padding-left: 20px;
    color: #00428e !important;
    font-weight: bold !important;
    width: 100% !important;
    background-color: #E1F1FF;
}


.row-form-item {
    margin-top: 10px;
}

.row-form-item .el-form-item {
    margin-right: 0;
}


.border-form .el-row.set_border {
    border-bottom: 0.5px solid #dadada;
    border-left: 0.5px solid #dadada;
    border-right: 0.5px solid #dadada;
}

.border-form .el-row.set_border:first-child {
    border-top: 0.5px solid #dadada;
}

.border-form .el-row.set_border .col-set_border {
    border-right: 0.5px solid #dadada;
}
</style>
